












































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";
import Customer from "@/types/customer/Customer";
import getters from "@/store/modules/customer/getters";
import router from "@/router";
import Endpoint from "@/utils/endpoint";
import formatDate from "@/utils/formatDate";
import UserInterface from "@/types/app/IUser";
import Header from "@/types/app/header";
import CustomerAproovedHeader from "@/components/headers/customer-approved";
import ModalAccountGrouping from "@/views/customers/group.vue";
import moment from "moment";
import applyCondition from "@/utils/applyCondition";
import ModalCustomer from "@/views/customers/detail.vue";
import ModalAccountMirror from "./mirror.vue";
import ErrorService from "@/services/erroService";
import ModalCloneAccount from "@/views/accounts/clone.vue";

import BaseComponent from "@/utils/baseComponent";
import RefreshStore from "@/services/refreshStore";
import { dataSanitizeException } from "@microsoft/applicationinsights-common";
const namespace = "customer";

@Component({
  components: {
    accountGrouping: ModalAccountGrouping,
    mirrorAccountModal: ModalAccountMirror,
    cloneAccount: ModalCloneAccount,
   
  },
  methods: {
    formatDate,
  },
})
export default class Customers extends BaseComponent {
  @Getter("getLoading", { namespace }) loading!: boolean;
  @Action("setLoading", { namespace }) setLoading!: any;
  @Action("removeCustomers", { namespace: "customer" }) removeCustomers!: any;
  @Getter("getCustomers", { namespace }) customers!: Customer[];
  @Getter("getCustomersAll", { namespace }) customersAll!: Customer[];
  @Getter("getUser", { namespace: "auth" }) user!: UserInterface;
  @Action("setModalAccountGroupingState", { namespace: "account" })
  setModalAccountGroupingState!: (modalIsVisible: boolean) => void;
  @Action("setModalCloneAccountState", { namespace: "account" })
  setModalCloneAccountState!: (modalIsVisible: boolean) => void;
  @Action("setCustomers", { namespace }) setCustomers!: any;
  @Action("setCustomer", { namespace }) setCustomer!: any;
  @Action("setModalCustomerState", { namespace }) setModalCustomerState!: any;
  @Action("setModalAccountMirrorState", { namespace: "customer" })
  setModalAccountMirrorState!: any;
 

  private endpoint = new Endpoint();

  headers: Array<Header> = CustomerAproovedHeader.header;
  fullNameFilter = "";
  emailFilter = "";
  countryFilter = "";
  relationshipFilter = "";
  selectedCustomer: any[] = [];
  items: any[] = [
    { title: "Click Me" },
    { title: "Click Me" },
    { title: "Click Me" },
    { title: "Click Me 2" },
  ];
  mounted() {
    this.getCustomers();
  }

  public getCustomers(): void {
    this.setLoading(true);
    this.$http
      .get(this.endpoint.customers)
      .then((resp) => {
        this.setCustomers([]);
        this.setCustomers(resp.data);
        this.setLoading(false);
      })
      .catch((err) => {
        this.setLoading(false);
        ErrorService.onError(err);
      });
  }

  get hasSelectToDelete() {
    return this.selectedCustomer.length > 0;
  }

  get filteredCustomers() {
    const conditions: any[] = [];
    if (this.fullNameFilter) {
      conditions.push((item: Customer) =>
        item.fullName.toLowerCase().includes(this.fullNameFilter.toLowerCase())
      );
    }

    if (this.emailFilter) {
      conditions.push((item: Customer) =>
        item.email.toLowerCase().includes(this.emailFilter.toLowerCase())
      );
    }

    if (this.countryFilter) {
      conditions.push((item: Customer) =>
        item.country.toLowerCase().includes(this.countryFilter.toLowerCase())
      );
    }

    if (this.relationshipFilter) {
      conditions.push((item: Customer) =>
        item.relationship
          .toString()
          .toLowerCase()
          .includes(this.relationshipFilter.toLowerCase())
      );
    }
    return applyCondition<Customer>(this.customers, conditions);
  }

  deleteCustomer(): void {
    this.$confirm("Do you really want to delete these customers?").then((res) => {
      if (res) {
        const url = `${this.endpoint.customers}`;
        const usersIdDisable = this.selectedCustomer.map((x) => x.id);
        this.setLoading(true);
        this.$http
          .delete(`${url}`, { data: { usersIdDisable } })
          .then((res: any) => {
            this.removeCustomers(usersIdDisable);
            this.selectedCustomer = [];
            this.setLoading(false);
          })
          .catch((err) => {
            this.setLoading(false);
            ErrorService.onError(err);
          });
      }
    });
  }

  showCloneAccountModal() {
    this.setModalCloneAccountState(true);
  }

 
  setModalCustomer(item: Customer): void {
    this.setCustomer(item);
    router.push({
      name: "UserForm",
      params: {
        customerId: item.id,
        formType: "view",
      }
    });
  }

  showAccountGroupingModal() {
    this.setModalAccountGroupingState(true);
  }

  showAccountMirrorModal() {
    this.setModalAccountMirrorState(true);
  }

  async exportCsv(all = false) {
    const customerExport = all ? this.customersAll : this.customers;
    const newArr = customerExport
      .map(dataCustomer => ({
        ...dataCustomer,
        familyMembersId: dataCustomer?.familyMembers?.map(x => x.email||x.name)?.join(';')
      }))
      .map(
        ({
          id,
          sentContracts,
          scheduleIndexResponse,
          notificationTypesEnable,
          notificationSent,
          veriffResponse,
          familyMembers,
          oldFamilyMembers,
          optionsThatApply,
          relationships,
          formsField,
          ...rest
        }) => {
          return rest;
        }
      )
      .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
    this.exportCSVFile([...newArr], `Customers-export`);
  }
}
